var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-y"},[_c('NoteList',{attrs:{"list":_vm.noteList,"is-loading":_vm.isLoading,"title":_vm.$t('text.loanNotes'),"loan-id":_vm.loan.id,"see-all":""},on:{"clickAll":_vm.clickAll}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }